import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


const Postviewer = () => {

    const query = useQuery();
    const notice_no = query.get('notice_no');
    const [post, setPost] = useState<any>(null);

    useEffect(() => {
        if (notice_no) {
            fetch(`/api/get-post?notice_no=${notice_no}`)
            .then((res) => res.json())
            .then((data) => setPost(data));
        }
    }, [notice_no]);

    if (!post) return (
        <div>
            <div className='License-box'>
                <div className='License-title'>
                    <a>쭉냥이가 열씨미 빅-데이터로 제목 쪄오는 중...</a>
                </div>
            </div>
            <div className='post-writer'>
                <a>작성자: 쭉냥이가 글 쓴 사람 데려오는 중...</a>
            </div>
            <hr className='post-hr'></hr>
            <div className='post-desc' >쭉냥이가 열씨미 글 본문 끌고오는 중... </div>
            <hr className='post-hr'></hr>
            <div className='edit-button-box'>
            <Link to={`/edit?notice_no=${notice_no}`}>
                <button className='edit-button'>수정</button>
            </Link>
            </div>
        </div>
    );
    
    return(
        <div>
            <div className='License-box'>
                <div className='License-title'>
                    <a>{post.notice_title}</a>
                </div>
            </div>
            <div className='post-writer'>
                <a>작성자: {post.notice_writer}</a>
            </div>
            <hr className='post-hr'></hr>
            <div dangerouslySetInnerHTML={{ __html: post.notice_desc }} className='post-desc'/>
            <hr className='post-hr'></hr>
            <div className='edit-button-box'>
            <Link to={`/post/edit?notice_no=${notice_no}`}>
                <button className='edit-button'>수정</button>
            </Link>
            </div>
        </div>

    );

};

export default Postviewer;
